import type { PluginOptions } from './type';
import { useSettingsStore } from '../stores';
import { getEmpCode } from '../utils/auth';

const options: PluginOptions = {
  onVuePluginRegister: async () => {
    const {
      settings: { feedbackConfig },
    } = useSettingsStore();
    if (!feedbackConfig.show) {
      return;
    }

    const userId = getEmpCode()
    if (feedbackConfig.appId && feedbackConfig.appSecret && userId) {
      // 意见反馈样式文件
      // @ts-ignore
      await import('@easy/feedback-pc-sdk/style.css');
      let { default: FeedbackPcSdk } = await import('@easy/feedback-pc-sdk');
      const { hostname } = window.location;
      const isSit = hostname.includes('.sit.');
      (window as any).feedbackSdk = new FeedbackPcSdk({
        ...feedbackConfig,
        userNo: userId || '',
        // @ts-ignore
        env: isSit || import.meta.env.DEV ? 'sit' : 'prd',
      });
      return;
    }

    let { default: KYFeedbackPC } = await import('./feedback-pc.min.js');
    if (!KYFeedbackPC) {
      ({ KYFeedbackPC } = window as any);
    }
    new KYFeedbackPC({
      ...feedbackConfig,
      userId: getEmpCode() || '',
    });
    // const { MODE } = (import.meta as unknown as { env: { MODE: 'production' | 'development'}}).env;
    // const script = document.createElement('script');
    // script.defer = true;
    // script.src = `https://freight${MODE === 'production' ? '' : '.sit'}.sf-express.com/publicResource/kyutils/feedback/1.0.0/feedback.min.js`;
    // script.onload = async () => {
    //   const settingsStore = useSettingsStore();
    //   const { feedbackConfig } = settingsStore.settings;
    //   new (window as any).KYFeedbackPC({ ...feedbackConfig, userId: getEmpCode() || '' });
    // };
    // document.body.appendChild(script);
  },
};

export default options;
